export default __webpack_public_path__ + "assets/images/storage365_object_defaultplacementimage_27VtK.jpg";